/* @flow strict */

import * as React from 'react';
import type { ProfileType, ProfileCurrent } from '/types/profile';

export const SERVER: 'server' = 'server';
export const BROWSER: 'browser' = 'browser';
export const WDS: 'wds' = 'wds';

export type RendererType = typeof SERVER | typeof BROWSER | typeof WDS;
export type MetaContextType = {
  renderer: RendererType,
  profile: ProfileType,
  profileCurrent?: ProfileCurrent,
  setProfile: (profile: ProfileType) => void,
  setFilterEventDashboard: (filter: []) => void
};
export const defaultMetaContext: MetaContextType = {
  renderer: SERVER,
  profile: null,
  profileCurrent: null, // Data from API
  setProfile: () => {},
  setProfileCurrent: () => {},
  setFilterEventDashboard: () => {}
};
export default React.createContext<MetaContextType>(defaultMetaContext);
